import { motion } from 'framer-motion';
import { useTranslation } from '@/lib/i18n';
import { Twitter, Facebook, Instagram, Linkedin } from 'lucide-react';

const teamMembers = [
  {
    name: 'Christian Ralph Hennig',
    role: 'owner',
    image: '/images/team/c2.jpg',
    socials: {
      twitter: 'https://twitter.com/Deinserverhost',
      facebook: 'https://www.facebook.com/DeinServerHost/',
      instagram: 'https://www.instagram.com/deinserverhost/',
    },
  },
  {
    name: 'Philip Michalski',
    role: 'development',
    image: '/images/team/team-2.png',
    socials: {},
  },
  {
    name: 'Andreas Wirtz',
    role: 'community',
    image: '/images/team/babsi.png',
    socials: {},
  },
];

const SocialIcon = ({ type, href }) => {
  const icons = {
    twitter: Twitter,
    facebook: Facebook,
    instagram: Instagram,
    linkedin: Linkedin,
  };
  const Icon = icons[type];

  if (!Icon || !href) return null;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="p-2 rounded-full bg-white/5 hover:bg-primary/20 text-muted-foreground hover:text-primary transition-colors"
      aria-label={type}
    >
      <Icon className="w-4 h-4" />
    </a>
  );
};

export const Team = () => {
  const { t } = useTranslation();

  return (
    <section className="section-spacing bg-card/30" data-testid="team-section">
      <div className="container-main">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}

          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            {t('team.title')}
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {t('team.subtitle')}
          </p>
        </motion.div>

        {/* Team Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {teamMembers.map((member, index) => (
            <motion.div
              key={member.name}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}

              transition={{ delay: index * 0.1 }}
              className="group"
            >
              <div className="relative overflow-hidden rounded-2xl bg-card border border-border p-6 text-center card-hover">
                {/* Image */}
                <div className="relative w-32 h-32 mx-auto mb-6 rounded-full overflow-hidden ring-4 ring-primary/20 group-hover:ring-primary/40 transition-all duration-300">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>

                {/* Info */}
                <h3 className="text-lg font-bold mb-1">{member.name}</h3>
                <p className="text-sm text-primary font-medium mb-4">
                  {t(`team.${member.role}`)}
                </p>

                {/* Socials */}
                {Object.keys(member.socials).length > 0 && (
                  <div className="flex items-center justify-center gap-2">
                    {Object.entries(member.socials).map(([type, href]) => (
                      <SocialIcon key={type} type={type} href={href} />
                    ))}
                  </div>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
